import { HttpClient } from '@angular/common/http';
import { Directive, inject } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';

@Directive()
export abstract class LoadStatisticsUseCase<REQUEST extends object, RESPONSE extends object> extends UseCase<
    REQUEST,
    Observable<RESPONSE>
> {
    protected _apiRequestService = inject(ApiRequestService);

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: REQUEST | void): Observable<RESPONSE> | void {
        return this._apiRequestService.sendRequest<REQUEST, RESPONSE>(
            this.getBackendUrl(),
            request as REQUEST,
            true,
            this.getApiUrl()
        );
    }

    protected abstract getBackendUrl(): string;
    protected abstract getApiUrl(): string;
}
